import axios from 'axios'
import { ElMessage } from 'element-plus'
import store from '@/store'
import router from '@/router'
import Cookies from 'js-cookie'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api',
  timeout: 15000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从store获取token
    const token = store.getters.token
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 如果是blob类型（文件下载），直接返回response.data
    if (response.config.responseType === 'blob') {
      return response.data
    }
    
    const res = response.data
    
    // 如果返回的状态码不是200，则认为是错误
    if (res && res.code !== undefined && (res.code !== 200)) {
      const errorMessage = res.message || '请求失败'
      
      ElMessage({
        message: errorMessage,
        type: 'error',
        duration: 5 * 1000
      })
      
      // 401: Token过期或未登录
      if (res.code === 401) {
        store.dispatch('user/logout').then(() => {
          router.push('/login')
        })
      }
      
      return Promise.reject(new Error(errorMessage))
    } else {
      return res
    }
  },
  error => {
    console.error('响应错误:', error)
    
    // 处理 HTTP 错误（如 500、404 等）
    let errorMessage = '网络错误'
    
    // 检查是否是超时错误
    if (error.code === 'ECONNABORTED' || error.message && error.message.includes('timeout')) {
      errorMessage = '请求超时，请稍后重试'
      // 对于导入接口的超时，不在这里显示错误，让调用方处理
      if (error.config && (error.config.url.includes('/import') || error.config.url.includes('/import/file'))) {
        return Promise.reject(error)
      }
    } else if (error.response) {
      // 服务器返回了响应，但状态码不在 2xx 范围内
      const res = error.response.data
      
      // 如果后端返回了 Result 格式的错误
      if (res && res.message) {
        errorMessage = res.message
      } else if (res && typeof res === 'string') {
        errorMessage = res
      } else if (error.response.status) {
        errorMessage = `请求失败 (${error.response.status})`
      }
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      errorMessage = '网络连接失败，请检查网络'
    } else if (error.message) {
      // 在设置请求时发生了一些事情，触发了错误
      errorMessage = error.message
    }
    
    // 对于导入接口的错误，不在这里显示，让调用方处理
    if (error.config && (error.config.url.includes('/import') || error.config.url.includes('/import/file'))) {
      return Promise.reject(error)
    }
    
    ElMessage({
      message: errorMessage,
      type: 'error',
      duration: 5 * 1000
    })
    
    return Promise.reject(error)
  }
)

export default service
